import { makeStyles } from '@material-ui/core';

export const useSelectedResidentCardStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    minWidth: 0,
    padding: '8px 12px',
    borderRadius: '10px',
    border: `1px solid ${theme.palette.colors.grey60}`,
    backgroundColor: theme.textWhite.main,
    boxSizing: 'border-box',
  },
  rootCompact: {
    alignSelf: 'stretch',
    height: '100%',
  },
  content: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-start',
    gap: '12px',
    minWidth: 0,
  },
  avatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '32px',
    height: '32px',
    borderRadius: '50px',
    padding: '2px',
    boxSizing: 'border-box',
    // Avatar gradient (#00656c → #228053) is not yet in theme.palette.colors.
    backgroundImage:
      'linear-gradient(95.6deg, #00656c 29.84%, #228053 114.37%)',
  },
  initials: {
    color: theme.textWhite.main,
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    textAlign: 'center',
  },
  copy: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: 0,
    justifyContent: 'center',
    minWidth: 0,
  },
  name: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontWeight: '700 !important',
    lineHeight: '24px',
    letterSpacing: '0.32px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  meta: {
    color: theme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: '0.28px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  removeButton: {
    flexShrink: 0,
    padding: '8px',
    color: theme.status.danger,
    alignSelf: 'center',
  },
}));
